export enum LoyaltyInMenuMode {
  Off = 'off',
  ShowLogInButton = 'show-log-in-button',
  PromptToLogInAtTheBeginning = 'prompt-to-log-in-at-the-beginning',
  PromptToLogInAtTheBeginningWithLoginOptions = 'prompt-to-log-in-at-the-beginning-with-login-options',
  PromptToLogInAtTheBeginningWithLoginOptionsPopup = 'prompt-to-log-in-at-the-beginning-with-login-options-popup',
}
